import request from '../utils/request';

export async function getDataGeo(address) {
    return await request(`data/geo?address=${address}`, 'get');
}